// 260513 리텐션 보드: FE 사용자 행동 추적 helper.
// 분석 데이터라 실패는 swallow — 본 비즈니스 흐름은 영향 받지 않음.
// 인증 토큰 없으면 호출 자체 skip (BE가 401로 거절하기 전에 차단).
import ServiceExec from '@/common/utils/ServiceExec';
import { retention } from '@/common/service/apiList';
import store from '@/store';

const isAuthed = () => {
  try {
    return !!store.getters['user/getAccessToken'];
  } catch {
    return false;
  }
};

const fire = async (path, payload) => {
  if (!isAuthed()) return;
  try {
    await ServiceExec.post(path, payload || {});
  } catch (_) {
    // swallow — 분석 데이터, 본 흐름 영향 없음
  }
};

/**
 * 앱 진입(세션 시작) 이벤트. App.vue mounted 시 1회 호출.
 * @param {string|null} appVersion - native bridge에서 받은 앱 버전 (없으면 null)
 */
export const trackSessionOpen = (appVersion = null) => fire(retention.sessionOpen, { appVersion });

/**
 * 핵심 기능 사용 이벤트. 사용자가 의도적으로 기능을 사용한 시점에 호출.
 * @param {string} feature - 'search' | 'message' | 'cooperation' | 'now_event' 등
 * @param {number|null} targetNo - 관련 대상 ID (signboard/business/post 등)
 */
export const trackFeature = (feature, targetNo = null) => {
  if (!feature) return;
  return fire(retention.feature, { feature, targetNo });
};
